
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

interface GaugeChartProps {
  value: number;
  max: number;
  label: string;
  color?: string;
}

const GaugeChart: React.FC<GaugeChartProps> = ({ 
  value, 
  max, 
  label,
  color = "#0081C5"
}) => {
  const percentage = (value / max) * 100;
  const data = [
    { name: 'value', value: percentage },
    { name: 'empty', value: 100 - percentage },
  ];

  const gradientOffset = () => {
    if (percentage >= 75) return 0;
    if (percentage <= 25) return 1;
    return 1 - (percentage - 25) / 50;
  };

  const offset = gradientOffset();

  return (
    <div className="relative w-full h-44 flex flex-col items-center">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <defs>
            <linearGradient id="gaugeGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset={offset} stopColor="#0081C5" />
              <stop offset={1 - offset} stopColor="#D600FC" />
            </linearGradient>
          </defs>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            startAngle={180}
            endAngle={0}
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={0}
            dataKey="value"
          >
            <Cell fill="url(#gaugeGradient)" />
            <Cell fill="#f3f4f6" />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute bottom-4 text-center">
        <div className="text-3xl font-bold gradient-text">{value}</div>
        <div className="text-sm text-gray-500">{label}</div>
      </div>
    </div>
  );
};

export default GaugeChart;
